import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const SaveVariableNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const config = props.data.config;

    if (!config) {
      return 'Clique para configurar';
    }

    const parts = [];

    if (config.variableName) {
      parts.push(`Variável: ${config.variableName}`);
    } else {
      parts.push('⚠️ Sem nome de variável');
    }

    if (config.validationType && config.validationType !== 'none') {
      const validationLabels: Record<string, string> = {
        email: '📧 Email',
        phone: '📱 Telefone',
        cpf: '🆔 CPF',
        cnpj: '🏢 CNPJ',
        number: '🔢 Número',
        date: '📅 Data',
        custom: '🔧 Regex Customizado',
      };
      parts.push(validationLabels[config.validationType] || 'Validação');
    }

    return parts.join(' • ');
  };

  return (
    <BaseNode
      {...props}
      icon="💾"
      label="Variável"
      color="#10b981"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

SaveVariableNode.displayName = 'SaveVariableNode';
